import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class GdoVehicleService {
  private reportedStolen = new Subject<any>();
  private reportSubscription = new Subject<any>();
  public subscriptionStatus: boolean = false;
 
  getSubscriptionStatus(): Observable<any> {
    return this.reportSubscription.asObservable();
  }

  setSubscriptionStatus(status: boolean) {
    this.subscriptionStatus = status;
    this.reportSubscription.next(status);
  }
}
